export default __webpack_public_path__ + "static/media/cover-laminate.41e13984.png";